import React, { useCallback } from 'react';

import { withTemplatePages } from '@sunwisesoftware/racking-template-core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import * as actions from '../../actions';

import AsideCol from './AsideCol';

const LeftSideMenu = ({
    deletePagesInTemplate,
    duplicatePagesInTemplate,
    orderPagesInTemplate,
    prepareDelete,
    templatePages,
    selectPage,
    selectedPageId,
}) => {
    const handlePrepareDelete = useCallback(
        (id, isPage) => {
            prepareDelete(isPage, () => deletePagesInTemplate(id));
        },
        [deletePagesInTemplate],
    );

    return (
        <AsideCol
            selectedPageId={selectedPageId}
            canUpdate
            onDuplicatePage={duplicatePagesInTemplate}
            onDeletePage={handlePrepareDelete}
            pages={templatePages}
            selectPage={selectPage}
            updateOrder={orderPagesInTemplate}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    prepareDelete: (isPage, callback) =>
        dispatch(actions.prepareDelete(isPage, callback)),
});

LeftSideMenu.propTypes = {
    deletePagesInTemplate: PropTypes.func,
    duplicatePagesInTemplate: PropTypes.func,
    selectedPageId: PropTypes.string,
    orderPagesInTemplate: PropTypes.func,
    prepareDelete: PropTypes.func,
    templatePages: PropTypes.array,
    selectPage: PropTypes.func,
};

export default compose(
    connect(null, mapDispatchToProps),
    withTemplatePages,
)(LeftSideMenu);
